<sam4-first-page-layout>
    <h1 class="text-danger" style="padding-top:12px;">Not Authorized</h1>
    <!--    <h2>Not Authorized</h2>-->
    <!--    <p>-->
    <!--        You can <a routerLink="/">return to the homepage</a>-->
    <!--    </p>-->
    <sam4-google-auth-button></sam4-google-auth-button>

    <a routerLink="/">Return to the homepage</a>
</sam4-first-page-layout>
